import Vue from 'vue';
import Vuex from 'vuex';
import adminAuth from './modules/admin/auth';
import adminMe from './modules/admin/me';
import adminSchool from './modules/admin/school';
import adminAccount from './modules/admin/account';
import adminOwner from './modules/admin/owner';
import adminNews from './modules/admin/news';
import auth from './modules/auth';
import itemSelect from './modules/itemSelect';
import file from './modules/file';
import me from './modules/me';
import school from './modules/school';
import tutor from './modules/tutor';
import student from './modules/student';
import recordControl from './modules/recordControl';
import recordList from './modules/recordList';
import recordView from './modules/recordView';
import enterLeave from './modules/enterLeave';
import message from './modules/message';
import chat from './modules/chat';
import report from './modules/report';
import manual from './modules/manual';
import schedule from './modules/schedule';
import calendar from './modules/calendar';
import reservation from './modules/reservation';
import reservationCalendar from './modules/reservationCalendar';
import reservableCount from './modules/reservableCount';
import studentCalendar from './modules/studentCalendar';
import bill from './modules/bill';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    adminAuth,
    adminMe,
    adminSchool,
    adminAccount,
    adminOwner,
    adminNews,
    auth,
    itemSelect,
    file,
    me,
    school,
    tutor,
    student,
    recordControl,
    recordList,
    recordView,
    enterLeave,
    message,
    chat,
    report,
    manual,
    schedule,
    calendar,
    reservation,
    reservationCalendar,
    reservableCount,
    studentCalendar,
    bill,
  }
});
